module.exports = __webpack_public_path__ + "distribution/img/touxiang.a7c963eb.png";